import { c as _c } from "react/compiler-runtime";
import { Button } from '@/app/components/button';
import { CardSharedContent } from '@/app/components/card/shared/content';
import { CardSharedImage } from '@/app/components/card/shared/image';
import type { DateProps } from '@/app/components/card/shared/meta/date-full';
import { IconArrowForward } from '@/app/components/icons/ui-actions/icon-arrow-forward';
import type { ImageProps } from '@/app/components/media/image/types';
import { Link } from '@/app/components/navigation/link';
import { TagItem } from '@/app/components/tags';
import { NEWS_ACTIVITIES_BASE_URL, NEWS_ACTIVITIES_EVENT_NAME } from '@/app/lcv/components/sections/news-activities/tracking';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA, type DataGAProps } from '@/app/utils/createDataGA';
import type { LcvNewsDetail } from '@/types/tis-cms/types';
export interface FeatureNewsCardProps extends LcvNewsDetail {
  className?: string;
  href?: string;
  dataGA?: DataGAProps;
  preload?: boolean;
  testId?: string;
  displayMode?: 'carousel' | 'list';
}
export const FeatureNewsCard = t0 => {
  const $ = _c(77);
  const {
    thumbnail,
    href: hrefProp,
    title,
    category,
    excerpt,
    beginDate,
    url,
    dataGA,
    className,
    preload: t1,
    displayMode: t2,
    testId: t3
  } = t0;
  const preload = t1 === undefined ? false : t1;
  const displayMode = t2 === undefined ? "list" : t2;
  const testId = t3 === undefined ? "card" : t3;
  const detailHref = category?.url && url ? `${NEWS_ACTIVITIES_BASE_URL}/${category.url}/${url}` : undefined;
  const href = hrefProp ?? detailHref;
  const isHoverable = !!href;
  if (!href) {
    return null;
  }
  let date;
  let t10;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== beginDate || $[1] !== category || $[2] !== className || $[3] !== dataGA?.eventName || $[4] !== displayMode || $[5] !== href || $[6] !== isHoverable || $[7] !== preload || $[8] !== testId || $[9] !== thumbnail || $[10] !== title) {
    const tag = category?.title && category?.url ? {
      label: category.title,
      href: `${NEWS_ACTIVITIES_BASE_URL}/${category.url}`
    } : undefined;
    let t11;
    if ($[19] !== beginDate) {
      t11 = beginDate != null && beginDate !== "" ? {
        startDate: beginDate as string
      } : null;
      $[19] = beginDate;
      $[20] = t11;
    } else {
      t11 = $[20];
    }
    date = t11;
    let t12;
    if ($[21] !== preload || $[22] !== thumbnail || $[23] !== title) {
      t12 = !!thumbnail?.url ? {
        src: thumbnail.url,
        alt: thumbnail.alternativeText ?? title ?? "",
        width: 640,
        height: 360,
        aspectRatio: "aspect-16-9",
        sizes: "(min-width: 1024px) 750px, 100vw",
        srcSetOptions: {
          crop: "16:9"
        },
        priority: preload,
        loadedEffect: "fade",
        placeholder: "shimmer"
      } : undefined;
      $[21] = preload;
      $[22] = thumbnail;
      $[23] = title;
      $[24] = t12;
    } else {
      t12 = $[24];
    }
    const image = t12;
    if ($[25] !== className) {
      t7 = cn("group relative flex h-full flex-col lg:grid lg:grid-cols-12 lg:flex-row", className);
      $[25] = className;
      $[26] = t7;
    } else {
      t7 = $[26];
    }
    const t13 = `${testId}-highlight`;
    if ($[27] !== t13) {
      t8 = createDataAttributes({
        testid: t13
      });
      $[27] = t13;
      $[28] = t8;
    } else {
      t8 = $[28];
    }
    if ($[29] !== displayMode || $[30] !== href || $[31] !== image || $[32] !== isHoverable || $[33] !== testId || $[34] !== title) {
      t9 = !!image?.src && <Link className={cn("card-scale absolute inset-0 lg:grid lg:grid-cols-12", {
        "card-outline rounded-lg bg-white": displayMode === "carousel",
        "lg:card-outline bg-silver-50 group-hover:bg-silver-100 lg:rounded-lg": displayMode === "list"
      })} href={href} {...createDataAttributes({
        testid: `${testId}-link`
      })} {...createDataGA({
        click: true,
        text: title,
        eventName: NEWS_ACTIVITIES_EVENT_NAME,
        url: href
      })}><CardSharedImage image={{
          ...image,
          className: cn("aspect-16-9 lg:col-span-8", {
            "rounded-t-lg lg:rounded-l-lg lg:rounded-r-none": displayMode === "carousel",
            "lg:rounded-l-lg": displayMode === "list"
          })
        }} isHoverable={isHoverable} /></Link>;
      $[29] = displayMode;
      $[30] = href;
      $[31] = image;
      $[32] = isHoverable;
      $[33] = testId;
      $[34] = title;
      $[35] = t9;
    } else {
      t9 = $[35];
    }
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <div className="aspect-16-9 lg:col-span-8" />;
      $[36] = t10;
    } else {
      t10 = $[36];
    }
    const t14 = displayMode === "carousel";
    const t15 = displayMode === "list";
    if ($[37] !== t14 || $[38] !== t15) {
      t4 = cn("flex grow flex-col gap-y-3 sm:gap-y-4 lg:col-span-4", "px-4 py-6 md:px-10 lg:py-12 xl:px-13", {
        "rounded-b-16 lg:rounded-r-16 lg:rounded-b-none": t14,
        "lg:rounded-r-16": t15
      });
      $[37] = t14;
      $[38] = t15;
      $[39] = t4;
    } else {
      t4 = $[39];
    }
    const t16 = `${testId}-content`;
    if ($[40] !== t16) {
      t5 = createDataAttributes({
        testid: t16
      });
      $[40] = t16;
      $[41] = t5;
    } else {
      t5 = $[41];
    }
    t6 = !!tag && <div className="relative z-10"><TagItem id={tag.href} href={tag.href} label={tag.label} tagCustomStyled={{
        base: "hover:bg-gray-800 hover:text-white hover:before:border-gray-800 focus-visible:bg-gray-800 focus-visible:text-white focus-visible:before:border-gray-800 active:bg-gray-800 active:text-white active:before:border-gray-800"
      }} {...createDataGA({
        click: true,
        eventName: `${dataGA?.eventName ?? "card"}-tag`,
        url: tag.href,
        text: tag.label,
        value: tag.href
      })} /></div>;
    $[0] = beginDate;
    $[1] = category;
    $[2] = className;
    $[3] = dataGA?.eventName;
    $[4] = displayMode;
    $[5] = href;
    $[6] = isHoverable;
    $[7] = preload;
    $[8] = testId;
    $[9] = thumbnail;
    $[10] = title;
    $[11] = date;
    $[12] = t10;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    date = $[11];
    t10 = $[12];
    t4 = $[13];
    t5 = $[14];
    t6 = $[15];
    t7 = $[16];
    t8 = $[17];
    t9 = $[18];
  }
  const t11 = displayMode === "carousel";
  const t12 = displayMode === "list";
  let t13;
  if ($[42] !== t11 || $[43] !== t12) {
    t13 = cn("where-span:text-inline-wrap group/link relative isolate flex grow flex-col items-start gap-y-2 before:pointer-events-none before:absolute before:inset-0 before:-z-10 md:gap-y-4", {
      "rounded-16": t11,
      "lg:before:rounded-16": t12
    });
    $[42] = t11;
    $[43] = t12;
    $[44] = t13;
  } else {
    t13 = $[44];
  }
  const t14 = `${testId}-link`;
  let t15;
  if ($[45] !== t14) {
    t15 = createDataAttributes({
      testid: t14
    });
    $[45] = t14;
    $[46] = t15;
  } else {
    t15 = $[46];
  }
  let t16;
  if ($[47] !== href || $[48] !== title) {
    t16 = createDataGA({
      click: true,
      text: title,
      eventName: NEWS_ACTIVITIES_EVENT_NAME,
      url: href
    });
    $[47] = href;
    $[48] = title;
    $[49] = t16;
  } else {
    t16 = $[49];
  }
  const t17 = excerpt?.textContent ?? "";
  let t18;
  if ($[50] !== date || $[51] !== t17 || $[52] !== title) {
    t18 = <div className="relative z-10"><CardSharedContent title={title} titleClassName="line-clamp-4 min-h-12 h-auto" description={t17} date={date} dateClassName="mt-4" /></div>;
    $[50] = date;
    $[51] = t17;
    $[52] = title;
    $[53] = t18;
  } else {
    t18 = $[53];
  }
  let t19;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <IconArrowForward />;
    $[54] = t19;
  } else {
    t19 = $[54];
  }
  const t20 = `${testId}-cta`;
  let t21;
  if ($[55] !== t20) {
    t21 = createDataAttributes({
      testid: t20
    });
    $[55] = t20;
    $[56] = t21;
  } else {
    t21 = $[56];
  }
  let t22;
  if ($[57] !== t21) {
    t22 = <Button className="mt-auto h-auto p-0 text-gray-900" as="div" size="sm" variant="tertiary" iconAfter={t19} width="auto" {...t21}>ดูรายละเอียด</Button>;
    $[57] = t21;
    $[58] = t22;
  } else {
    t22 = $[58];
  }
  let t23;
  if ($[59] !== href || $[60] !== t13 || $[61] !== t15 || $[62] !== t16 || $[63] !== t18 || $[64] !== t22) {
    t23 = <Link className={t13} href={href} {...t15} {...t16}>{t18}{t22}</Link>;
    $[59] = href;
    $[60] = t13;
    $[61] = t15;
    $[62] = t16;
    $[63] = t18;
    $[64] = t22;
    $[65] = t23;
  } else {
    t23 = $[65];
  }
  let t24;
  if ($[66] !== t23 || $[67] !== t4 || $[68] !== t5 || $[69] !== t6) {
    t24 = <div className={t4} {...t5}>{t6}{t23}</div>;
    $[66] = t23;
    $[67] = t4;
    $[68] = t5;
    $[69] = t6;
    $[70] = t24;
  } else {
    t24 = $[70];
  }
  let t25;
  if ($[71] !== t10 || $[72] !== t24 || $[73] !== t7 || $[74] !== t8 || $[75] !== t9) {
    t25 = <article className={t7} {...t8}>{t9}{t10}{t24}</article>;
    $[71] = t10;
    $[72] = t24;
    $[73] = t7;
    $[74] = t8;
    $[75] = t9;
    $[76] = t25;
  } else {
    t25 = $[76];
  }
  return t25;
};